import { auth, firestore, storage } from './FirebaseConfig';
import {
  getDoc,
  getDocs,
  doc,
  setDoc,
  collection,
  addDoc,
  query,
  where,
  deleteDoc,
} from '@firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
} from 'firebase/auth';


import { syncAlgoliaWithFirestore, searchRides } from './algoliaService'; 
const usersCollectionRef = collection(firestore, 'users');
const ridesCollectionRef = collection(firestore, 'rides');

// create new user with e-mail and password

export const createUser = async (
  email,
  password,
  firstName,
  lastName,
  phoneNumber,
  file
) => {
  try {
    const { user } = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );

    // Upload the image file to Firebase Storage
    const storageRef = ref(storage, `user_images/${user.uid}`);
    await uploadBytes(storageRef, file);

    // Get the download URL of the uploaded file
    const fileUrl = await getDownloadURL(storageRef);

    const userRef = doc(firestore, 'users', user.uid);
    const userSnap = await getDoc(userRef);
    if (!userSnap.exists()) {
      await setDoc(userRef, {
        email: email,
        firstName: firstName,
        phoneNumber: phoneNumber,
        lastName: lastName,
        file: fileUrl,
        uid: user.uid,
      });



      console.log(`Name: ${firstName}, Email: ${email}, PhotoURL: ${fileUrl}`);
      await updateProfile(user, {
        displayName: firstName, // Set the user's name
        photoURL: fileUrl, // Set the user's photo URL
      });
    }
    // Create a userChats collection for the new user
    const userChatsRef = doc(firestore, 'userChats', user.uid);
    const userChatsSnap = await getDoc(userChatsRef);
    if (!userChatsSnap.exists()) {
      await setDoc(userChatsRef, {});
    }

    return user;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Login
export const loginUser = async (email, password) => {
  try {
    const userCreds = await signInWithEmailAndPassword(auth, email, password);

    return userCreds;
  } catch (error) {
    throw new Error('User Login failed');
  }
};

// Get user info
export const getUserInfo = async (id) => {
  try {
    const userDocRef = doc(usersCollectionRef, id);
    const docSnapshot = await getDoc(userDocRef);

    if (docSnapshot.exists()) {
      const user = docSnapshot.data();
      return user;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

// Create new ride
export const createRide = async (data) => {
  try {
    await addDoc(ridesCollectionRef, data);

    return true;
  }
  catch (error) {

    throw error;
    return false;
  }
};

// Get all rides
export const getAllRides = async () => {
  try {
    
    const ridesSnapshot = await getDocs(ridesCollectionRef);
    const rides = ridesSnapshot.docs.map((doc) => {
      // Get the document data
      const data = doc.data();
      // Get the document ID
      const id = doc.id;
      // Return an object with both data and id
      return {
        id, // this will be the document's ID
        ...data, // this will contain the rest of the document's data
      };
    });
    console.log(rides)
    syncAlgoliaWithFirestore(rides);
    return rides;
  } catch (error) {
    throw error;
  }
};

// Get ride by id
export const getRideById = async (id) => {
  try {
    const rideDocRef = doc(ridesCollectionRef, id);
    const docSnapshot = await getDoc(rideDocRef);

    if (docSnapshot.exists()) {
      const ride = docSnapshot.data();

      return ride;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

//Get rides by user id

export const getRidesDriverByUserId = async (userId) => {
  try {
    const q = query(ridesCollectionRef, where('driver', '==', userId));

    const querySnapshot = await getDocs(q);
    const rides = querySnapshot.docs.map((doc) => ({
      id: doc.id, // include the document ID
      ...doc.data(), // include the document data
    }));

    return rides;
  } catch (error) {
    throw error;
  }
};

//Get rides as passenger by user id

export const getRidesPassengerByUserId = async (userId) => {
  try {
    // Query documents where the "passenger" array field contains the specified userId
    const q = query(
      ridesCollectionRef,
      where('passengers', 'array-contains', userId)
    );

    const querySnapshot = await getDocs(q);
    const rides = querySnapshot.docs.map((doc) => ({
      id: doc.id, // include the document ID
      ...doc.data(), // include the document data
    }));
    console.log(rides);
    return rides;
  } catch (error) {
    console.error('Error fetching rides: ', error);
    throw error;
  }
};

// reserve a ride
export const reserveRide = async (rideId, userId) => {
  try {
    const rideDocRef = doc(ridesCollectionRef, rideId);
    const docSnapshot = await getDoc(rideDocRef);

    if (docSnapshot.exists()) {
      const ride = docSnapshot.data();
      const passengers = ride.passengers;

      passengers.push(userId);
      await setDoc(rideDocRef, {
        ...ride,
        passengers: passengers,
      });
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const cancelRide = async (rideId) => {
  try {
    const rideDocRef = doc(ridesCollectionRef, rideId);

    await deleteDoc(rideDocRef);

    return true;
  } catch (error) {
    console.error('Error deleting ride:', error);
    return false;
  }
};
